<template >
  <div>
    <v-btn 
      v-if='!user.complete'
      class="mb-2"
      color="primary"
      @click="flagForReview">Submit</v-btn>
    <v-dialog
      v-model='submitDialog'
      max-width="500px"
      persistent>
      <v-card>
        <v-card-text
          v-if="!wasTrue"
          class="pa-10">
          Thank you for submitting your My Genetic Trust for review.
        </v-card-text>
        <v-card-text
          v-else
          class="pa-10">
          You have already submitted your genetic trust. A genetic counselor will contact you once it has been reviewed.
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            justify="right"
            @click="reroute()">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
  import { mapFields } from 'vuex-map-fields';
  import { flagSwitch } from '../helper/firestore'
  import router from '@/router';

  export default {
    props: {
      label: String
    },
    data() {
      return {
        submitDialog: false,
        wasTrue: false,
      }
    },
    mounted() {
    },
    methods : {
      flagForReview() {
        this.wasTrue = this.user.reviewFlag;
        this.submitDialog = true;
        flagSwitch(this.user.reviewFlag, (res) => {
          this.user.reviewFlag = true;
        })
      },
      reroute() {
        if(!this.wasTrue){
          router.replace('/home');
        }
        this.submitDialog=false;
      }
    },
    computed : {
      ...mapFields([
        'isAuthorized',
        'user',
        'snackBarshow',
        'snackBarType',
        'snackBarmessage',
      ]),
      ...mapFields("patientQuestion", [
        "dataModel",
      ]),
    },
  }
</script>
<style>
  .v-input__slot .v-label{
    color: black
  }
</style>
